import { render, staticRenderFns } from "./GuppyChatRequestsList.vue?vue&type=template&id=3358e95c"
import script from "./GuppyChatRequestsList.vue?vue&type=script&lang=js"
export * from "./GuppyChatRequestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports